import intlTelInput from 'intl-tel-input';
import { en, pt, sv, fi, nl, de, es, hu, pl, bg, sk, cs, ro, fr, it, hr, da } from 'intl-tel-input/i18n';

document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('freshdesk-form');
  if (form) {
    const i18nTranslations = {
      en,
      pt,
      sv,
      fi,
      nl,
      de,
      es,
      hu,
      pl,
      bg,
      sk,
      cs,
      ro,
      fr,
      it,
      hr,
      da,
    };

    const input = document.querySelector('#phone');

    intlTelInput(input, {
      initialCountry: getSecondPart(prestashop.language.language_code) || 'gb',
      separateDialCode: true,
      i18n: i18nTranslations[prestashop.language.iso_code] || en,
      loadUtils: '/theme/vasco-theme/lib/telUtils.js',
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      const phoneNumberElement = form.elements['b2b-phonenumber'];
      const phoneCountryCode = phoneNumberElement.parentElement.querySelector('.iti__selected-dial-code').innerText;

      const data = {
        name: form.elements['b2b-name'].value,
        jobTitle: form.elements['b2b-jobtitle'].value,
        email: form.elements['b2b-email'].value,
        phoneNumber: phoneCountryCode + phoneNumberElement.value,
        landingId: form.elements['b2b-landingId'].value,
        langCode: prestashop.language.language_code.toLowerCase(),
      };

      postFreshDeskData(prestashop.modules.ve_freshdeskforms.freshdeskModuleFrontController, data);
      sendDatalayerEvent(form.elements['b2b-landingId'].value, form.elements['b2b-jobtitle'].value);

      form.reset();
    });
  }
});

function postFreshDeskData(controller, requestData) {
  $.post(controller, {
    action: 'sendDataToFreshdesk',
    requestData: requestData,
  })
    .done(function () {
      showSuccessToast();
    })
    .fail(function () {
      console.log('error');
    });
}

function showSuccessToast() {
  document.querySelector('.freshdesk-confirmation-screen').classList.add('show');
}

function sendDatalayerEvent(landingId, jobTitle) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'b2b_form',
    pagetype: landingId,
    event_action: jobTitle.toLowerCase(),
  });
}

function getSecondPart(input) {
  if (!input.includes('-')) {
    return null;
  }
  return input.split('-')[1];
}

if (document.getElementById('freshdesk-form')) {
  const formNodeButtons = document.querySelectorAll('.scrollToForm');
  const header = document.getElementById('header');
  const headerHeight = header ? header.offsetHeight : 0;
  const form = document.getElementById('freshdesk-form-section')
    ? document.getElementById('freshdesk-form-section')
    : document.getElementById('freshdesk-form');

  formNodeButtons.forEach(node => {
    node.addEventListener('click', function () {
      let formPosition = form.getBoundingClientRect().top + window.scrollY;

      window.scrollTo({
        top: formPosition - headerHeight,
        behavior: 'smooth',
      });
    });
  });
}
